import moment from "moment";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, Spinner, Table } from "reactstrap";
import Breadcrumbs from "../../../components/Breadcrumbs";
import Container from "../../../components/Container";
import AppLayout from "../../../components/layouts/AppLayout";
import API from "../../../utils/API";
import Create from "./Create";
import Delete from "./Delete";
import Edit from "./Edit";

const Index = () => {
  const [sessions, setSessions] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(true);

  const fetchSessions = async () => {
    try {
      const data = (await API.get("/api/sessions")).data.data;
      setSessions(data);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSessions();
  }, [refresh]);

  return (
    <AppLayout>
      <Breadcrumbs
        title="Sessions"
        links={[
          {
            title: "Dashboard",
            link: null,
          },
          {
            title: "Sessions",
            link: null,
          },
        ]}
      />
      <Container>
        <Card className="border-0 shadow mt-5" style={{ minHeight: "70vh" }}>
          <CardBody>
            <div className="d-flex align-items-center justify-content-between mb-4">
              <h1 className="mb-0">All Sessions</h1>
              <Create Session={sessions} fetchSessions={fetchSessions} />
            </div>
            <Table hover responsive>
              <thead>
                <tr className="bg-shade-blue">
                  <th>#</th>
                  <th>Name</th>
                  <th>Session</th>
                  <th>Campus</th>
                  <th>Year</th>
                  <th>Created At</th>
                  <th>Updated At</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {sessions.length > 0 ? (
                  sessions.map((session, index) => (
                    <tr
                      key={`session-${session?.id}`}
                      style={{ verticalAlign: "middle" }}>
                      <th scope="row">{index + 1}</th>
                      <td>{session?.name}</td>
                      <td>{session?.relationships?.session_type?.name}</td>
                      <td>{session?.relationships?.campus?.name}</td>
                      <td>{session?.year}</td>
                      <td>{moment(session?.created_at).format("DD/MM/YY")}</td>
                      <td>{moment(session?.updated_at).format("DD/MM/YY")}</td>
                      <td>
                        <Edit session={session} fetchSessions={fetchSessions} />
                        <Delete
                          session={session}
                          refresh={refresh}
                          setRefresh={setRefresh}
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={10} className="text-center">
                      {loading ? (
                        <Spinner style={{ width: "30px", height: "30px" }} />
                      ) : (
                        "No Sessions Exists"
                      )}
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </Container>
    </AppLayout>
  );
};

export default Index;
